import { FC, ReactNode } from 'react';
import { Wrapper } from './styles';

type Props = {
  children: ReactNode;
};

const SideAccountRegister: FC<Props> = ({ children }) => (
  <Wrapper titlePage="Cadastro" hiddenBorder offPaddingContent>
    {children}
  </Wrapper>
);

export default SideAccountRegister;
